import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import ClubWalletHubPage from './pages/ClubWalletHubPage';
import ClubWalletPortalPage from './pages/ClubWalletPortalPage';
import LoginPage from './pages/LoginPage';
import RecoverPasswordPage from './pages/RecoverPasswordPage';
import WalletClubsPage from './pages/WalletClubsPage';
import { isAuthenticated } from './services/authStorage';
import './styles/App.css';

const HomeRedirect: React.FC = () => {
  return <Navigate to={isAuthenticated() ? '/clubs' : '/login'} replace />;
};

const NotFoundPage: React.FC = () => (
  <div className="wallet-not-found">
    <div className="wallet-not-found__card">
      <span>404</span>
      <h1>Pagina nao encontrada</h1>
      <p>O portal financeiro nao encontrou a rota solicitada.</p>
      <a href="/clubs">Voltar para clubs</a>
    </div>
  </div>
);

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/recovery" element={<RecoverPasswordPage />} />
      <Route
        path="/clubs"
        element={
          <ProtectedRoute>
            <WalletClubsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clubs/:clubId/wallet"
        element={
          <ProtectedRoute>
            <ClubWalletHubPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clubs/:clubId/wallet/deposit"
        element={
          <ProtectedRoute>
            <ClubWalletPortalPage mode="deposit" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clubs/:clubId/wallet/withdraw"
        element={
          <ProtectedRoute>
            <ClubWalletPortalPage mode="withdraw" />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<HomeRedirect />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
